export default function PrivacyPolicy({ onClose }) {
  const ov = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,.72)',
    zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 20, fontFamily: "'Outfit',sans-serif",
  };
  const box = {
    background: '#161b22', border: '1px solid #21262d', borderRadius: 16,
    width: '100%', maxWidth: 680, maxHeight: '88vh',
    display: 'flex', flexDirection: 'column',
  };
  const hd = {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '18px 24px', borderBottom: '1px solid #21262d', flexShrink: 0,
  };
  const body = {
    overflowY: 'auto', padding: '24px 28px',
    color: '#c9d1d9', fontSize: 13, lineHeight: 1.8,
  };
  const h2 = { fontFamily: "'Playfair Display',serif", fontSize: 18, fontWeight: 800, color: '#fff', marginBottom: 6 };
  const h3 = { fontSize: 14, fontWeight: 700, color: '#f5f0e8', margin: '20px 0 6px' };
  const p  = { marginBottom: 12, color: '#8b949e' };

  return (
    <div style={ov} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={box}>
        <div style={hd}>
          <div style={h2}>Privacy Policy</div>
          <button
            style={{ background: 'none', border: '1px solid #2d333b', borderRadius: 8, color: '#8b949e', cursor: 'pointer', padding: '4px 10px', fontSize: 18, lineHeight: 1 }}
            onClick={onClose}>×</button>
        </div>

        <div style={body}>
          <p style={{ ...p, color: '#484f58', fontSize: 12 }}>Last updated: January 1, 2026 · Effective: January 1, 2026</p>

          <p style={p}>
            At RentLord, your privacy is important to us. This Privacy Policy explains how we collect, use, disclose,
            and protect your information when you use our property management platform.
          </p>

          <div style={h3}>1. Information We Collect</div>
          <p style={p}><strong style={{ color: '#f5f0e8' }}>Account Information:</strong> Name, email address, password (hashed), and role (landlord or tenant) when you create an account.</p>
          <p style={p}><strong style={{ color: '#f5f0e8' }}>Property & Tenant Data:</strong> Property addresses, unit information, lease terms, rent amounts, payment records, and maintenance history that you enter into the platform.</p>
          <p style={p}><strong style={{ color: '#f5f0e8' }}>Usage Data:</strong> Log data, IP addresses, browser type, pages visited, and actions taken within the app to improve performance and security.</p>
          <p style={p}><strong style={{ color: '#f5f0e8' }}>Communications:</strong> Messages sent through the in-app messaging feature between landlords and tenants.</p>

          <div style={h3}>2. How We Use Your Information</div>
          <p style={p}>We use your information to:</p>
          <p style={p}>• Provide, operate, and improve the RentLord platform</p>
          <p style={p}>• Process payments and generate receipts</p>
          <p style={p}>• Send transactional emails (receipts, notices, maintenance updates)</p>
          <p style={p}>• Ensure platform security and prevent fraud</p>
          <p style={p}>• Comply with legal obligations</p>
          <p style={p}>• Respond to support requests</p>

          <div style={h3}>3. Data Storage and Security</div>
          <p style={p}>
            Your data is stored on Supabase infrastructure (AWS us-east-1) with encryption at rest and in transit.
            We implement industry-standard security measures including Row Level Security (RLS), ensuring each landlord
            can only access their own data. We are pursuing SOC 2 Type II certification.
          </p>

          <div style={h3}>4. Data Sharing</div>
          <p style={p}>
            We do not sell your personal data to third parties. We share data only with:
          </p>
          <p style={p}>• <strong style={{ color: '#f5f0e8' }}>Service providers</strong> who help operate our platform (Supabase for database, Resend for email, Stripe for payments) — bound by data processing agreements</p>
          <p style={p}>• <strong style={{ color: '#f5f0e8' }}>Law enforcement</strong> when required by valid legal process</p>
          <p style={p}>• <strong style={{ color: '#f5f0e8' }}>Successors</strong> in the event of a merger or acquisition, with prior notice to you</p>

          <div style={h3}>5. Landlord and Tenant Data</div>
          <p style={p}>
            Landlords on our platform enter data about their tenants. If you are a tenant, your landlord controls
            the data entered about you. Contact your landlord to request corrections or deletion of your personal
            information from their account. RentLord acts as a data processor for landlord-entered tenant data.
          </p>

          <div style={h3}>6. Cookies and Tracking</div>
          <p style={p}>
            We use essential cookies required for authentication and session management. We do not use third-party
            advertising cookies or sell behavioral data for targeted advertising. You can disable cookies in your
            browser settings, but this may affect platform functionality.
          </p>

          <div style={h3}>7. Data Retention</div>
          <p style={p}>
            We retain your account data for as long as your account is active. After account deletion, we retain
            data for up to 90 days for backup purposes, then permanently delete it. Payment records may be retained
            for up to 7 years for tax and legal compliance.
          </p>

          <div style={h3}>8. Your Rights</div>
          <p style={p}>Depending on your location, you may have rights to:</p>
          <p style={p}>• Access a copy of your personal data</p>
          <p style={p}>• Correct inaccurate information</p>
          <p style={p}>• Delete your account and associated data</p>
          <p style={p}>• Export your data in a portable format</p>
          <p style={p}>• Opt out of non-essential communications</p>
          <p style={p}>To exercise these rights, email us at <strong style={{ color: '#4ade80' }}>privacy@rentlordapp.com</strong>.</p>

          <div style={h3}>9. Children's Privacy</div>
          <p style={p}>
            RentLord is not directed to children under 18. We do not knowingly collect personal information from
            minors. If you believe we have collected information from a child, contact us immediately.
          </p>

          <div style={h3}>10. Texas Privacy Rights</div>
          <p style={p}>
            Texas residents have additional rights under the Texas Data Privacy and Security Act (TDPSA), including
            the right to opt out of the sale of personal data (we do not sell data) and the right to appeal our
            decisions regarding your data requests.
          </p>

          <div style={h3}>11. Changes to This Policy</div>
          <p style={p}>
            We may update this Privacy Policy periodically. We will notify you of significant changes via email or
            in-app notification at least 30 days before they take effect. Your continued use of the platform
            constitutes acceptance of the updated policy.
          </p>

          <div style={h3}>12. Contact Us</div>
          <p style={p}>
            Privacy questions or requests: <strong style={{ color: '#4ade80' }}>privacy@rentlordapp.com</strong>
            <br/>General support: <strong style={{ color: '#4ade80' }}>support@rentlordapp.com</strong>
            <br/>RentLord LLC · Dallas, TX 75201
          </p>
        </div>

        <div style={{ padding: '14px 24px', borderTop: '1px solid #21262d', flexShrink: 0, display: 'flex', justifyContent: 'flex-end' }}>
          <button
            style={{ background: 'linear-gradient(135deg,#16a34a,#4ade80)', color: '#0a1a0a', border: 'none', borderRadius: 8, padding: '10px 24px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: "'Outfit',sans-serif" }}
            onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}
